"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DataSolid: function() {
        return DataSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const DataSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsxs)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.9945 6.73074C17.5143 6.73074 21.989 5.67173 21.989 4.36537C21.989 3.05901 17.5143 2 11.9945 2C6.4747 2 2 3.05901 2 4.36537C2 5.67173 6.4747 6.73074 11.9945 6.73074Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.9945 8.54098C15.8369 8.54098 19.7014 7.96352 21.989 6.80859V9.07402C21.989 10.1734 17.9912 11.8059 11.9945 11.8059C5.99781 11.8059 2 10.1845 2 9.07402V6.80859C4.28764 7.96352 8.16329 8.54098 11.9945 8.54098Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.9945 13.6382C15.8369 13.6382 19.7014 12.9941 21.989 11.7615V14.1713C21.989 15.2596 17.9912 16.9031 11.9945 16.9031C5.99781 16.9031 2 15.2596 2 14.1713V11.7615C4.28764 12.9941 8.16329 13.6382 11.9945 13.6382Z",
            fill: "currentColor"
        }),
        /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
            d: "M11.9945 18.7129C15.8369 18.7129 19.7014 18.0688 21.989 16.8362V19.2682C21.989 20.3565 17.9912 22 11.9945 22C5.99781 22 2 20.3565 2 19.2682V16.8362C4.28764 18.0688 8.16329 18.7129 11.9945 18.7129Z",
            fill: "currentColor"
        })
    ]
}), "DataSolid");
const _default = DataSolid;
